/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

;;(function () {
  // Add custom code below this line

  // Detect if the current page locale uses comma as decimal separator
  const localeUsesComma = (() => {
    try {
      const lang = document.documentElement.lang || 'en'
      return new Intl.NumberFormat(lang).format(1.1).includes(',')
    } catch {
      return true
    }
  })()

  // Locale-adjusted money format: swaps comma↔dot format based on page language
  const getLocaleMoneyFormat = () => {
    const format = window.theme?.moneyFormat || '{{amount_with_comma_separator}}\u20AC'
    return localeUsesComma
      ? format
      : format
          .replace('amount_with_comma_separator', 'amount')
          .replace('amount_no_decimals_with_comma_separator', 'amount_no_decimals')
  }

  // Wrapper around Shopify's native formatMoney using locale-adjusted format
  const shopifyFormatMoney = (cents) => {
    const fmt = getLocaleMoneyFormat()
    if (typeof themeVendor !== 'undefined' && themeVendor?.themeCurrency?.formatMoney) {
      return themeVendor.themeCurrency.formatMoney(cents, fmt)
    }
    if (window.Shopify?.formatMoney) {
      return Shopify.formatMoney(cents, fmt)
    }
    return (cents / 100).toFixed(2)
  }

  /*----------------------------------------------
   Eventos del carrousel de connectif:
----------------------------------------------*/
  const carrouselConnectifEvents = () => {
    const carruseles = document.querySelectorAll('#cn_carruselHome, #cn_product_carrusel')

    if (!carruseles.length) return

    carruseles.forEach((carrusel) => {
      const observer = new MutationObserver(() => {
        const slides = carrusel.querySelector('.cn__slides')
        if (slides && !slides.dataset.enhanced) {
          slides.dataset.enhanced = 'true' // Para evitar duplicar funcionalidades
          habilitarScrollConArrastre(slides)
          agregarFlechas(carrusel, slides)
          ocultarPrecioDuplicado(slides)
          actualizarURLsDeImagenes(slides)
        }
      })

      observer.observe(carrusel, { childList: true, subtree: true })
    })

    function habilitarScrollConArrastre(container) {
      let isDown = false
      let startX
      let scrollLeft
      let isDragging = false

      container.style.cursor = 'grab'

      container.addEventListener('mousedown', (e) => {
        isDown = true
        isDragging = false
        container.classList.add('dragging')
        container.style.cursor = 'grabbing'
        startX = e.pageX - container.offsetLeft
        scrollLeft = container.scrollLeft
      })

      container.addEventListener('mouseleave', () => {
        isDown = false
        container.classList.remove('dragging')
        container.style.cursor = 'grab'
      })

      container.addEventListener('mouseup', (e) => {
        isDown = false
        container.classList.remove('dragging')
        container.style.cursor = 'grab'

        if (isDragging) {
          e.preventDefault()
          e.stopPropagation()
        }
      })

      container.addEventListener('mousemove', (e) => {
        if (!isDown) return
        e.preventDefault()
        isDragging = true
        const x = e.pageX - container.offsetLeft
        const walk = (x - startX) * 1.5
        container.scrollLeft = scrollLeft - walk
      })

      container.querySelectorAll('*').forEach((el) => {
        el.setAttribute('draggable', 'false')
        el.style.userSelect = 'none'
        el.style.pointerEvents = el.tagName === 'A' ? 'auto' : 'auto'
      })

      // Pero permitir selección y clic en <a> o botones si se necesita
      container.querySelectorAll('a, button').forEach((el) => {
        el.style.userSelect = 'auto'
      })
    }

    function agregarFlechas(wrapper, container) {
      const leftArrow = document.createElement('button')
      const rightArrow = document.createElement('button')

      leftArrow.classList.add('carrousel_arrow')
      rightArrow.classList.add('carrousel_arrow')

      leftArrow.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#222222">
          <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/>
          </svg>`
      rightArrow.innerHTML = `
       <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#222222">
        <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
       </svg>`

      Object.assign(leftArrow.style, estiloFlecha('left'))
      Object.assign(rightArrow.style, estiloFlecha('right'))

      leftArrow.addEventListener('click', () => {
        container.scrollBy({ left: -300, behavior: 'smooth' })
      })

      rightArrow.addEventListener('click', () => {
        container.scrollBy({ left: 300, behavior: 'smooth' })
      })

      wrapper.appendChild(leftArrow)
      wrapper.appendChild(rightArrow)

      // Escuchamos el scroll y actualizamos el estado
      container.addEventListener('scroll', () => {
        actualizarEstadoFlechas(container, leftArrow, rightArrow)
      })

      // También lo hacemos al inicio por si ya está al borde
      actualizarEstadoFlechas(container, leftArrow, rightArrow)
    }

    function actualizarEstadoFlechas(container, leftArrow, rightArrow) {
      const scrollLeft = container.scrollLeft
      const maxScrollLeft = container.scrollWidth - container.clientWidth

      leftArrow.disabled = scrollLeft <= 0
      rightArrow.disabled = scrollLeft >= maxScrollLeft - 1 // tolerancia de 1px
    }

    function estiloFlecha(pos) {
      return {
        [pos]: 'var(--gutter-custom)'
      }
    }
    function ocultarPrecioDuplicado(slidesContainer) {
      const items = slidesContainer.querySelectorAll('.cn__li')

      items.forEach((item) => {
        const precios = Array.from(item.querySelectorAll('.product-price'))

        const getNumero = (el) => {
          const texto = el.textContent || ''
          const soloNumeros = texto.replace(/[^\d,.]/g, '').replace(',', '.')
          const numero = parseFloat(soloNumeros)
          return isNaN(numero) ? null : { numero, el }
        }

        // Extraer solo los precios con números válidos
        const preciosValidos = precios.map(getNumero).filter((p) => p !== null)

        if (preciosValidos.length >= 2) {
          const primero = preciosValidos[0]
          const segundo = preciosValidos[1]

          if (primero.numero >= segundo.numero) {
            segundo.el.remove()
          }
        }
      })
    }

    function actualizarURLsDeImagenes(slidesContainer) {
      const imagenes = slidesContainer.querySelectorAll('img')

      imagenes.forEach((img) => {
        let url = new URL(img.src)

        // Si ya están los parámetros correctos, no hacemos nada
        const hasCorrectHeight = url.searchParams.get('height') === '1200'
        const hasCorrectWidth = url.searchParams.get('width') === '967'

        if (!hasCorrectHeight) url.searchParams.set('height', '1200')
        if (!hasCorrectWidth) url.searchParams.set('width', '967')

        // Actualizamos el src con los nuevos parámetros
        img.src = url.toString()
      })
    }
  }
  /*----------------------------------------------
   Eventos del botón sticky de de los filtros:
----------------------------------------------*/

  const stickyFilterButtonEvents = () => {
    const stickyButton = document.querySelector('.filter-button-sticky')
    const wrapper = document.querySelector('#CollectionStickyBar')
    const footer = document.querySelector('footer')

    // Verificamos si los elementos existen
    if (!stickyButton || !wrapper || !footer) {
      console.warn('Faltan los elementos necesarios.')
      return
    }

    let isWrapperVisible = true
    let isFooterVisible = false

    const updateStickyButtonVisibility = () => {
      if (!isWrapperVisible && !isFooterVisible) {
        stickyButton.classList.add('visible')
      } else {
        stickyButton.classList.remove('visible')
      }
    }

    // Observer callback
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.target === wrapper) {
          isWrapperVisible = entry.isIntersecting
        } else if (entry.target === footer) {
          isFooterVisible = entry.isIntersecting
        }
      })

      updateStickyButtonVisibility()
    }

    // Opciones del observer
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.01
    }

    const observer = new IntersectionObserver(handleIntersection, observerOptions)
    observer.observe(wrapper)
    observer.observe(footer)
  }

  const bindOpenFilterButtons = () => {
    const toggleFilters = () => {
      const filtersElement = document.querySelector('[data-collection-filters]')
      if (!filtersElement) return

      const isVisible = filtersElement.classList.contains('collection__filters--visible')

      if (isVisible) {
        filtersElement.classList.remove('collection__filters--visible')
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }))
      } else {
        filtersElement.classList.add('collection__filters--visible')
        const scrollableElement = document.querySelector('[data-collection-filters-list]')
        document.dispatchEvent(
          new CustomEvent('theme:scroll:lock', { bubbles: true, detail: scrollableElement })
        )
      }
    }

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-action="open-filter"]')
      if (!trigger) return
      event.preventDefault()
      toggleFilters()
    })
  }

  /*----------------------------------------------
   Cambiar imágenes del carrousel de reviews en home:
----------------------------------------------*/
  const reviewImageHight = () => {
    const cleanCarouselImages = () => {
      const images = document.querySelectorAll(
        '.jdgm-carousel-item__product-image:not([data-processed="true"])'
      )

      images.forEach((img) => {
        if (!img.src || !img.src.startsWith('http')) return
        let url = new URL(img.src)

        // Si ya están los parámetros correctos, no hacemos nada
        const hasCorrectHeight = url.searchParams.get('height') === '1200'
        const hasCorrectWidth = url.searchParams.get('width') === '967'

        if (!hasCorrectHeight) url.searchParams.set('height', '1200')
        if (!hasCorrectWidth) url.searchParams.set('width', '967')

        // Actualizamos el src con los nuevos parámetros
        img.src = url.toString()
      })
    }

    // Observador de mutaciones
    const observer = new MutationObserver((mutations, obs) => {
      const container = document.querySelector('.jdgm-carousel__item-container')
      if (container) {
        cleanCarouselImages()
        // Si necesitas re-ejecutar en caso de cambios (como scroll infinito), no desconectes
        // obs.disconnect();
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true
    })

    // Por si ya está cargado antes de que MutationObserver lo vea
    if (document.querySelector('.jdgm-carousel__item-container')) {
      cleanCarouselImages()
    }
  }

  /*----------------------------------------------
   Aplicar descuento a través de cookie:
----------------------------------------------*/
  class VipDiscount {
    constructor({ gridSelector = '.collection__products .grid' } = {}) {
      this.gridSelector = gridSelector
      this.#persistVipFromUrl()
      this.#observeGrid()
      this.#initProductPageDiscount()
      document.addEventListener('click', (e) => this.#onQuickBuy(e))
    }

    static #cookie(name) {
      return document.cookie.split(`; ${name}=`)[1]?.split(';')[0]
    }

    static #toNumber(txt = '') {
      const t = txt
        .trim()
        .replace(/[^\d,.-]/g, '')
        .replace(/\s+/g, '')
      const comma = t.lastIndexOf(',')
      const dot = t.lastIndexOf('.')
      const norm = comma > dot ? t.replace(/\./g, '').replace(',', '.') : t.replace(/,/g, '')
      return parseFloat(norm)
    }

    static #toMoney(amount) {
      return shopifyFormatMoney(Math.round(amount * 100))
    }

    static #getDiscountsCookie() {
      const val = document.cookie.split('; vip_discounts=').pop().split(';')[0]
      return val ? val.split(',') : []
    }

    static #setDiscountsCookie(codes) {
      document.cookie = `vip_discounts=${codes.join(',')}; path=/`
    }

    #persistVipFromUrl() {
      const code = new URLSearchParams(location.search).get('vip')
      if (!code) return
      const exp = new Date(Date.now() + 30 * 24 * 60 * 60 * 1e3)
      document.cookie = `vip=${code}; expires=${exp.toUTCString()}; path=/`
    }

    async #applyDiscount(map) {
      const vip = VipDiscount.#cookie('vip')
      if (!vip || !map[vip]) return

      // 1. Leer/deserializar cookie
      let discounts = VipDiscount.#getDiscountsCookie()

      // 2. Añadir el nuevo si no está
      if (!discounts.includes(map[vip])) {
        discounts.push(map[vip])
        VipDiscount.#setDiscountsCookie(discounts)
      }

      // 3. Aplicar todos los descuentos guardados
      try {
        await fetch(`/checkout?discount=${discounts.join(',')}`)
      } catch (err) {
        // Silenciar error CORS
      }
    }

    async #onQuickBuy(evt) {
      if (!evt.target.closest('.btn-quick-buy')) return
      evt.preventDefault()
      const priceEl = evt.target
        .closest('[data-product-block]')
        ?.querySelector('a.product-grid-item__price[data-discounts]')
      if (!priceEl) return

      let map = {}
      try {
        const raw = JSON.parse(priceEl.dataset.discounts)
        map = this.#normalizeDiscounts(raw)
      } catch {}

      await this.#applyDiscount(map)
    }

    #normalizeDiscounts(raw = []) {
      return (Array.isArray(raw) ? raw : [raw]).reduce((acc, d) => {
        if (typeof d === 'object') {
          if (d.code && d.name) acc[d.code] = d.name
          else if (Object.keys(d).length === 1) {
            const k = Object.keys(d)[0]
            acc[k] = d[k]
          }
        }
        return acc
      }, {})
    }

    #observeGrid() {
      const container = document.querySelector(this.gridSelector)
      const root = container ?? document.body
      this.#updatePrices(root)
      if (!container) return

      new MutationObserver((muts) =>
        muts.forEach(({ addedNodes }) => {
          addedNodes.forEach((n) => n.nodeType === 1 && this.#updatePrices(n))
        })
      ).observe(container, { childList: true, subtree: true })
    }

    #updatePrices(scope) {
      const vipCodes = VipDiscount.#cookie('vip')?.split(',') || []
      if (!vipCodes.length) return

      scope
        .querySelectorAll('a.product-grid-item__price[data-discounts]:not([data-discount-applied])')
        .forEach((el) => {
          let discounts
          try {
            discounts = JSON.parse(el.dataset.discounts)
          } catch {
            return
          }
          if (!Array.isArray(discounts)) return

          const best = discounts
            .filter((d) => vipCodes.includes(d.code) && d.percentage > 0)
            .sort((a, b) => b.percentage - a.percentage)[0]
          if (!best) return

          const newEl = el.querySelector('.product-grid-item__price-new')
          const oldEl = el.querySelector('s')
          const currentNum = VipDiscount.#toNumber((newEl || el).textContent)
          const originalNum = VipDiscount.#toNumber((oldEl || el).textContent)
          if (isNaN(currentNum) || isNaN(originalNum)) return

          let cents = Math.round(currentNum * 100)
          let discountedCents = Math.ceil(cents * (1 - best.percentage / 100))
          let discounted = discountedCents / 100

          el.innerHTML = `<span class=\"product-grid-item__price-new\">${VipDiscount.#toMoney(
            discounted
          )}</span><s>${VipDiscount.#toMoney(originalNum)}</s>`
          el.dataset.discountApplied = 'true'
        })
    }

    // --- PRODUCT PAGE LOGIC ---
    #initProductPageDiscount() {
      // Detectar si estamos en ficha de producto por discountData global
      if (typeof window.discountData === 'undefined' || !window.discountData.discounts) {
        return
      }
      if (
        !Array.isArray(window.discountData.discounts) ||
        window.discountData.discounts.length === 0
      ) {
        return
      }
      const vip = VipDiscount.#cookie('vip')
      if (!vip) {
        return
      }
      // Buscar el objeto de descuento cuyo code coincide con la cookie VIP
      const discountObj = window.discountData.discounts.find((d) => d.code === vip)
      if (!discountObj) {
        return
      }
      // Mostrar el precio con descuento usando el objeto real
      this.#updateProductPagePrice(discountObj)
      // Aplicar automáticamente el descuento vía AJAX
      // (opcional: si necesitas mapear para applyDiscount)
      const map = {}
      window.discountData.discounts.forEach((d) => {
        map[d.code] = d.name
      })
      this.#applyDiscount(map)
    }

    #updateProductPagePrice(discountObj) {
      // Helpers de la clase
      const toNumber = VipDiscount.#toNumber
      const toMoney = VipDiscount.#toMoney
      // Elementos base
      const priceWrapper = document.querySelector('[data-price-wrapper]')
      if (!priceWrapper) return
      let customPriceWrapper = document.getElementById('vip-price-wrapper')
      if (!customPriceWrapper) {
        customPriceWrapper = priceWrapper.cloneNode(true)
        customPriceWrapper.id = 'vip-price-wrapper'
        customPriceWrapper.setAttribute('data-price-wrapper-custom', 'true')
        customPriceWrapper.classList.add('vip-price-wrapper')
        customPriceWrapper.classList.remove('product__price-wrapper')
        const newParent = document.querySelector('.product__price-and-badge')
        if (newParent) newParent.appendChild(customPriceWrapper)
        else priceWrapper.parentNode.insertBefore(customPriceWrapper, priceWrapper)
        if (!document.getElementById('custom-price-style')) {
          const style = document.createElement('style')
          style.id = 'custom-price-style'
          style.innerHTML = `.product__price-wrapper { display: none !important; }\n#vip-price-wrapper { display: flex !important; }`
          document.head.appendChild(style)
        }
      }
      // Elementos de precio
      const originalPriceEl = priceWrapper.querySelector('[data-product-price]')
      const originalComparePriceEl = priceWrapper.querySelector('[data-compare-price]')
      const customPriceEl = customPriceWrapper.querySelector('[data-product-price]')
      const customComparePriceEl = customPriceWrapper.querySelector('[data-compare-price]')
      if (!originalPriceEl || !customPriceEl || !customComparePriceEl) return
      // Calcula precios base
      const priceValue = toNumber(originalPriceEl.textContent)
      const comparePriceValue = toNumber(originalComparePriceEl?.textContent || '')
      const discount = parseInt(discountObj.percentage, 10) || 0
      if (!discount || isNaN(priceValue)) return
      // Calcula precios finales
      const discounted = Math.floor(priceValue * (1 - discount / 100) * 100) / 100
      const compare =
        !isNaN(comparePriceValue) && comparePriceValue > priceValue ? comparePriceValue : priceValue
      // Aplica en el clon
      customPriceEl.innerHTML = toMoney(discounted, originalPriceEl)
      customComparePriceEl.innerHTML = toMoney(compare, originalComparePriceEl || originalPriceEl)
      customComparePriceEl.className = originalComparePriceEl.className
      customComparePriceEl.classList.remove('hidden')
      // Observer para mantener el clon actualizado
      if (!customPriceWrapper.__vipObserverAttached) {
        const observer = new MutationObserver(() => {
          const priceValue = toNumber(originalPriceEl.textContent)
          const comparePriceValue = toNumber(originalComparePriceEl?.textContent || '')
          const cents = Math.round(priceValue * 100)
          const discountedCents = Math.ceil(cents * (1 - discount / 100))
          const discounted = discountedCents / 100
          const compare =
            !isNaN(comparePriceValue) && comparePriceValue > priceValue
              ? comparePriceValue
              : priceValue
          customPriceEl.innerHTML = toMoney(discounted, originalPriceEl)
          customComparePriceEl.innerHTML = toMoney(
            compare,
            originalComparePriceEl || originalPriceEl
          )
          customComparePriceEl.className = originalComparePriceEl.className
          customComparePriceEl.classList.remove('hidden')
        })
        observer.observe(priceWrapper, {
          childList: true,
          subtree: true,
          characterData: true
        })
        customPriceWrapper.__vipObserverAttached = true
      }
    }
  }
  /*----------------------------------------------
    Carousel de tallas personalizado para filtros
----------------------------------------------*/
  const customTallaFilterCarousel = () => {
    // Animación de entrada para el wrapper del carrusel de tallas
    var wrapper = document.querySelector('.custom-talla-carousel-wrapper')
    if (wrapper) {
      setTimeout(function () {
        wrapper.classList.add('talla-fade-in')
      }, 400)
    }
    document.querySelectorAll('form[action*="/collections/"]').forEach((form) => {
      form.addEventListener('submit', () => {
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('custom-talla-sync'))
        }, 100)
      })
    })
    document.addEventListener('change', (e) => {
      if (e.target && e.target.matches('input.filter__input[name="filter.v.option.talla"]')) {
        document.dispatchEvent(new CustomEvent('custom-talla-sync'))
      }
    })
    document.querySelectorAll('label[for^="filter-Talla-"]').forEach((label) => {
      label.addEventListener('mousedown', (e) => {
        if (e.detail && e.detail === 777) {
          e.preventDefault()
          e.stopPropagation()
        }
      })
      label.addEventListener('click', (e) => {
        if (e.detail && e.detail === 777) {
          e.preventDefault()
          e.stopPropagation()
        }
      })
      label.addEventListener('focus', (e) => {
        if (e.detail && e.detail === 777) {
          e.preventDefault()
          e.stopPropagation()
        }
      })
    })

    document
      .querySelectorAll('[data-collapsible-trigger], .collection__filter__title, .facets__summary')
      .forEach((trigger) => {
        trigger.addEventListener('mousedown', (e) => {
          if (e.detail && e.detail === 777) {
            e.preventDefault()
            e.stopPropagation()
          }
        })
        trigger.addEventListener('click', (e) => {
          if (e.detail && e.detail === 777) {
            e.preventDefault()
            e.stopPropagation()
          }
        })
        trigger.addEventListener('focus', (e) => {
          if (e.detail && e.detail === 777) {
            e.preventDefault()
            e.stopPropagation()
          }
        })
      })

    const carousel = document.getElementById('custom-talla-carousel')
    if (!carousel) return
    const buttons = carousel.querySelectorAll('.talla-carousel-item')

    const syncActiveButtons = () => {
      // Obtiene los parámetros activos de talla de la URL
      const url = new URL(window.location.href)
      // Shopify puede tener múltiples filter.v.option.talla
      const tallaParams = url.searchParams.getAll('filter.v.option.talla')

      // La disponibilidad la gestiona stockAwareFilters() de forma condicional
      // (solo cuando hay algún filtro activo). Aquí solo sincronizamos el estado
      // visual de los botones del carrusel con la URL.
      buttons.forEach((btn) => {
        const talla = btn.getAttribute('data-talla')
        // Marca activo si está en los parámetros de la URL
        btn.classList.toggle('active', tallaParams.includes(talla))
      })
    }

    syncActiveButtons()

    const tallaFilterWrapper = document.querySelector(
      '.facets__list, .collection__filter-tags, .filter-group__options'
    )
    if (tallaFilterWrapper && window.MutationObserver) {
      const observer = new MutationObserver(() => {
        syncActiveButtons()
        document.dispatchEvent(new CustomEvent('custom-talla-sync'))
      })
      observer.observe(tallaFilterWrapper, { childList: true, subtree: true, attributes: true })
    }

    document.addEventListener('custom-talla-sync', syncActiveButtons)

    // --- Sincronización robusta de tallas por cambio de URL (polling + eventos de navegación) ---
    if (!window._talla_last_url) window._talla_last_url = location.href
    setInterval(() => {
      if (location.href !== window._talla_last_url) {
        window._talla_last_url = location.href
        console.log('[TALLA] Cambio de URL detectado (polling):', location.href)
        syncActiveButtons()
      }
    }, 100)
    function syncActiveButtonsWithLog() {
      console.log('[TALLA] Cambio de URL detectado (evento):', location.href)
      window._talla_last_url = location.href
      syncActiveButtons()
    }
    window.addEventListener('popstate', syncActiveButtonsWithLog)
    // Monkeypatch pushState y replaceState para detectar navegación AJAX
    ;(function (history) {
      const pushState = history.pushState
      const replaceState = history.replaceState
      history.pushState = function () {
        const ret = pushState.apply(this, arguments)
        window.dispatchEvent(new Event('pushstate'))
        window.dispatchEvent(new Event('locationchange'))
        return ret
      }
      history.replaceState = function () {
        const ret = replaceState.apply(this, arguments)
        window.dispatchEvent(new Event('replacestate'))
        window.dispatchEvent(new Event('locationchange'))
        return ret
      }
    })(window.history)
    window.addEventListener('pushstate', syncActiveButtonsWithLog)
    window.addEventListener('replacestate', syncActiveButtonsWithLog)
    window.addEventListener('locationchange', syncActiveButtonsWithLog)

    buttons.forEach((btn) => {
      btn.addEventListener('click', function (e) {
        e.preventDefault()
        e.stopPropagation()
        const talla = btn.getAttribute('data-talla')
        const section = document.querySelector(
          'section[data-section-type="collection-template"], .shopify-section[data-section-type="collection-template"]'
        )
        const filtrosSection = document
          .querySelector('.collection__filters')
          .closest('.collection__inner')
        if (section) {
          section.classList.add('hidden-by-talla')
        }
        if (filtrosSection) {
          filtrosSection.classList.add('hidden-by-talla')
        }

        const toggleBtn = document.querySelector('.collection__filters__toggle')
        if (toggleBtn) {
          toggleBtn.click()
        }
        const filtersEl = document.querySelector('.collection__filters')
        setTimeout(() => {
          const interval = setInterval(() => {
            const toggleBtn = document.querySelector('.collection__filters__toggle')
            if (toggleBtn) {
              toggleBtn.click()
            }
            if (filtersEl && !filtersEl.classList.contains('collection__filters--visible')) {
              if (section) section.classList.remove('hidden-by-talla')
              if (filtrosSection) filtrosSection.classList.remove('hidden-by-talla')
              clearInterval(interval)
            }
          }, 100)
        }, 2000)
        let found = false
        const inputEls = document.querySelectorAll(
          'input.filter__input[name="filter.v.option.talla"]'
        )
        inputEls.forEach(function (input) {
          if (input.value.trim() === talla) {
            input.click()
            found = true
          }
        })
        document.dispatchEvent(new CustomEvent('custom-talla-sync'))
      })
    })
  }

  /*----------------------------------------------
    Lanzar video automaticos de forma lazy
----------------------------------------------*/
  const lazyVideos = () => {
    let lazyVideos2 = [...document.querySelectorAll('.lazy-video.lazy')]
    const _videoPlay = (video) => {
      video.muted = true
      video.load()
      video.setAttribute('autoplay', '')
      const _playOk = () => {
        video.classList.remove('lazy')
        var promise = video.play()
        if (promise) promise.catch(function () {})
        video.removeEventListener('canplay', _playOk)
      }
      video.addEventListener('canplay', _playOk)
    }
    if ('IntersectionObserver' in window) {
      let lazyVideoObserver = new IntersectionObserver((entries) => {
        entries.forEach((video) => {
          video.isIntersecting &&
            (_videoPlay(video.target), lazyVideoObserver.unobserve(video.target))
        })
      })
      lazyVideos2.forEach((lazyVideo) => {
        lazyVideoObserver.observe(lazyVideo)
      })
    } else {
      lazyVideos2.forEach((lazyVideo) => {
        _videoPlay(lazyVideo)
      })
      const _resiceCheckVideo = () => {
        let lazyVideos3 = [...document.querySelectorAll('.lazy-video.lazy')]
        lazyVideos3.forEach((lazyVideo) => {
          _videoPlay(lazyVideo)
        }),
          (lazyVideos3 = [...document.querySelectorAll('.lazy-video.lazy')]),
          lazyVideos3.length == 0 && window.removeEventListener('resize', _resiceCheckVideo)
      }
      window.addEventListener('resize', _resiceCheckVideo)
    }
  }

  /*----------------------------------------------
    Gestionar eventos video banner
----------------------------------------------*/
  const videoBannerEvents = () => {
    const wrappers = document.querySelectorAll('.video-banner__wrapper, .media-banner__wrapper')
    function isMobile() {
      return window.innerWidth <= 767
    }

    // Auto-play videos within media-banner wrappers
    const videos = document.querySelectorAll('.media-banner__video')
    if (videos.length) {
      const playVideo = (video) => {
        video.muted = true
        video.setAttribute('autoplay', '')
        video.addEventListener('canplay', function handler() {
          video.removeEventListener('canplay', handler)
          const promise = video.play()
          if (promise) promise.catch(function () {})
        })
        video.load()
      }
      const onPlaying = (video) => {
        const wrap = video.closest('.media-banner__media-wrap')
        if (wrap) wrap.classList.add('is-playing')
      }
      videos.forEach((video) => {
        video.addEventListener('playing', () => onPlaying(video))
      })
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                playVideo(entry.target)
                observer.unobserve(entry.target)
              }
            })
          },
          { threshold: 0.25 }
        )
        videos.forEach((video) => observer.observe(video))
      } else {
        videos.forEach((video) => playVideo(video))
      }
    }
    const initializeWrapper = (wrapper) => {
      const rows = wrapper.querySelectorAll('.video-banner__row, .media-banner__slide')
      if (rows.length === 0) return
      let dotsContainer = wrapper.parentElement.querySelector('.dots-container-video-banner')
      dotsContainer ||
        ((dotsContainer = document.createElement('div')),
        (dotsContainer.className = 'dots-container-video-banner')),
        (dotsContainer.innerHTML = ''),
        rows.forEach((row, index) => {
          const dot = document.createElement('div')
          ;(dot.className = 'dot'),
            index === 0 && dot.classList.add('active'),
            (dot.dataset.index = index),
            dot.addEventListener('click', () => {
              const scrollPosition = wrapper.scrollWidth * (index / rows.length)
              wrapper.scrollTo({ left: scrollPosition, behavior: 'smooth' }),
                updateActiveClasses(index)
            }),
            dotsContainer.appendChild(dot)
        }),
        wrapper.parentElement.contains(dotsContainer) ||
          ((wrapper.parentElement.style.position = 'relative'),
          wrapper.parentElement.appendChild(dotsContainer))
      let currentIndex = 0
      function updateActiveClasses(index) {
        rows.forEach((row, i2) => {
          i2 === index ? row.classList.add('active') : row.classList.remove('active')
        }),
          dotsContainer.querySelectorAll('.dot').forEach((dot, i2) => {
            i2 === index ? dot.classList.add('active') : dot.classList.remove('active')
          }),
          (currentIndex = index)
      }
      function autoSwitchRow() {
        currentIndex = (currentIndex + 1) % rows.length
        const scrollPosition = wrapper.scrollWidth * (currentIndex / rows.length)
        wrapper.scrollTo({ left: scrollPosition, behavior: 'smooth' }),
          updateActiveClasses(currentIndex)
      }
      const interval = setInterval(autoSwitchRow, 1e4)
      wrapper.addEventListener('scroll', () => {
        const scrollLeft = wrapper.scrollLeft,
          totalWidth = wrapper.scrollWidth - wrapper.clientWidth,
          index = Math.round((scrollLeft / totalWidth) * (rows.length - 1))
        updateActiveClasses(index)
      })
      const resizeHandler = () => {
        isMobile()
          ? (wrapper.parentElement.contains(dotsContainer) ||
              wrapper.parentElement.appendChild(dotsContainer),
            updateActiveClasses(currentIndex))
          : (clearInterval(interval),
            rows.forEach((row) => row.classList.remove('active')),
            dotsContainer.parentElement && dotsContainer.remove())
      }
      window.addEventListener('resize', resizeHandler), updateActiveClasses(0)
    }

    const checkScreenSizeAndInitialize = () => {
      wrappers.forEach((wrapper) => {
        if (isMobile()) initializeWrapper(wrapper)
        else {
          const dotsContainer = wrapper.parentElement.querySelector('.dots-container-video-banner')
          dotsContainer && dotsContainer.remove()
        }
      })
    }
    checkScreenSizeAndInitialize(), window.addEventListener('resize', checkScreenSizeAndInitialize)
  }

  /*----------------------------------------------
    Cambiar variante seleccionada en grid product
----------------------------------------------*/
  const changeVariantSelected = () => {
    const grids = document.querySelectorAll('.product-colors-grid')
    if (!grids.length) return

    const formatMoney = (cents) => shopifyFormatMoney(cents)

    grids.forEach((grid) => {
      const dataScript = grid.querySelector('#product-colors-data')
      if (!dataScript) return

      let data
      try {
        data = JSON.parse(dataScript.textContent)
      } catch (e) {
        return
      }

      grid.addEventListener('click', (e) => {
        const box = e.target.closest('.product-colors__box')
        if (!box || !grid.contains(box)) return

        const link = e.target.closest('.product-colors__box a')
        if (link) {
          e.preventDefault()
          e.stopPropagation()
        }

        const clickedId = (link && link.getAttribute('data-id')) || box.getAttribute('data-id')
        const targetById = (data.colors || []).find((c) => String(c.id) === String(clickedId))
        const target =
          targetById ||
          (String(data.main?.id) === String(clickedId) ? data.main : null) ||
          (link ? (data.colors || []).find((c) => c.url === link.getAttribute('href')) : null) ||
          data.main
        if (!target) return

        const card = grid.closest('[data-product-block]') || grid.closest('.product-grid-item')
        if (!card) return

        // Activar el color clicado visualmente
        grid.querySelectorAll('.product-colors__box').forEach((b) => b.classList.remove('active'))
        box.classList.add('active')

        // Elementos de la card
        const mediaLink = card.querySelector(
          '.product-grid-item__image a.product__media__holder, .product-grid-item__image a[data-grid-link]'
        )
        const titleLink = card.querySelector('.product-grid-item__info a.product-grid-item__title')
        const priceLink = card.querySelector('.product-grid-item__info a.product-grid-item__price')
        const quickBuy = card.querySelector('.product-grid-item__quick-buy a')
        const mainImg =
          card.querySelector('[data-product-image] img') ||
          card.querySelector('.product__media__image img') ||
          card.querySelector('.product__media__image--hover-fade-in img') ||
          card.querySelector('figure[data-product-image] img')
        const hoverImg =
          card.querySelector('[data-product-image-hover] img') ||
          card.querySelector('.product__media__hover img') ||
          card.querySelector('.product__media__hover-img img') ||
          card.querySelector('figure[data-product-image-hover] img')

        const setImg = (imgEl, url) => {
          if (!imgEl || !url) return
          imgEl.src = url
          imgEl.removeAttribute('srcset')
          imgEl.removeAttribute('sizes')
          const fig = imgEl.closest('figure')
          if (fig && fig.style) fig.style.backgroundImage = ''
        }

        // Actualizar hrefs y labels
        ;[mediaLink, titleLink, priceLink, quickBuy].forEach((a) => {
          if (a && target.url) a.setAttribute('href', target.url)
        })
        if (titleLink && target.title) {
          titleLink.textContent = target.title
          titleLink.setAttribute('aria-label', target.title)
        }
        if (mediaLink && target.title) mediaLink.setAttribute('aria-label', target.title)
        if (quickBuy && target.url) {
          const handle = target.url.split('/products/').pop()
          if (handle) quickBuy.setAttribute('data-handle', handle)
        }

        // Actualizar imágenes
        setImg(mainImg, target.image_1)
        setImg(hoverImg, target.image_2)

        // Actualizar precio
        if (priceLink && typeof target.price === 'number') {
          const hasDiscount =
            typeof target.compare_at_price === 'number' && target.compare_at_price > target.price
          if (hasDiscount) {
            priceLink.innerHTML = `<span class="product-grid-item__price-new">${formatMoney(
              target.price
            )}</span><s>${formatMoney(target.compare_at_price)}</s>`
          } else {
            priceLink.textContent = formatMoney(target.price)
          }
        }
      })
    })
  }

  /*----------------------------------------------
    Filtros de colección conscientes del stock
    Añade filter.v.availability=1 solo cuando hay algún filtro activo
    (se filtre como se filtre), para que al filtrar por talla/color solo
    aparezcan productos con esa variante en stock. Sin filtros, se muestran
    también los agotados. Apoyado en el motor nativo de Shopify (matching a
    nivel de variante), sin filtrar en Liquid tras la paginación.
----------------------------------------------*/
  const stockAwareFilters = () => {
    if (!window.location.pathname.includes('/collections/')) return
    if (window.__stockAwareFiltersInit) return

    const AVAILABILITY = 'filter.v.availability'

    const hasOtherFilter = (params) => {
      for (const key of params.keys()) {
        if (key.indexOf('filter.') === 0 && key !== AVAILABILITY) return true
      }
      return false
    }
    const isInStockActive = (params) => params.getAll(AVAILABILITY).includes('1')

    // Ajusta los params a la regla de stock. Devuelve true si los modificó.
    const applyStockRule = (params) => {
      const other = hasOtherFilter(params)
      const inStock = isInStockActive(params)
      if (other && !inStock) {
        params.append(AVAILABILITY, '1')
        return true
      }
      if (!other && inStock) {
        params.delete(AVAILABILITY)
        return true
      }
      return false
    }

    // Carga inicial / enlaces compartidos: normaliza la URL una sola vez.
    const initialParams = new URLSearchParams(window.location.search)
    if (applyStockRule(initialParams)) {
      const qs = initialParams.toString()
      window.location.replace(window.location.pathname + (qs ? '?' + qs : ''))
      return // la página recarga; se reinicializa
    }

    window.__stockAwareFiltersInit = true

    // Filtrado AJAX: inyecta/retira availability en las peticiones de sección.
    const nativeFetch = window.fetch
    window.fetch = function (input, init) {
      try {
        if (
          typeof input === 'string' &&
          window.location.pathname.includes('/collections/') &&
          input.indexOf('section_id=') !== -1 &&
          input.indexOf('filter.') !== -1
        ) {
          const u = new URL(input, window.location.origin)
          if (applyStockRule(u.searchParams)) input = u.toString()
        }
      } catch (e) {}
      return nativeFetch.call(this, input, init)
    }

    // Barra de direcciones: mantén la URL coherente con lo filtrado.
    const wrapHistory = (method) => {
      const native = history[method]
      history[method] = function (state, title, url) {
        try {
          if (
            url &&
            window.location.pathname.includes('/collections/') &&
            String(url).indexOf('filter.') !== -1
          ) {
            const u = new URL(url, window.location.origin)
            if (applyStockRule(u.searchParams)) {
              url = u.pathname + u.search
              if (state && typeof state.searchParams === 'string') {
                state = Object.assign({}, state, { searchParams: u.searchParams.toString() })
              }
            }
          }
        } catch (e) {}
        return native.call(this, state, title, url)
      }
    }
    wrapHistory('pushState')
    wrapHistory('replaceState')
  }

  /*----------------------------------------------
    Listar eventos cuando el documentos este listo:
----------------------------------------------*/
  const eventsListener = () => {
    stockAwareFilters()
    carrouselConnectifEvents()
    stickyFilterButtonEvents()
    bindOpenFilterButtons()
    reviewImageHight()
    new VipDiscount()
    customTallaFilterCarousel()
    lazyVideos()
    videoBannerEvents()
    changeVariantSelected()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      eventsListener()
    })
  } else {
    eventsListener()
  }

  // Expose for theme.dev.js and globo.preorder
  window.__shopifyFormatMoney = shopifyFormatMoney

  /*----------------------------------------------
    Global price reformatting based on locale
    shop.money_format is fixed as {{amount_with_comma_separator}} for all languages
    This reformats Liquid-rendered prices client-side to match the active language
  ----------------------------------------------*/
  const initPriceReformat = () => {
    // Only reformat if the locale expects dot as decimal separator
    if (localeUsesComma) return

    // Parse a price string like "75,99€", "€75.99", "1.234,56€" into a number
    const parsePrice = (text) => {
      if (!text) return null
      const cleaned = text.trim().replace(/[^\d,.\-]/g, '')
      if (!cleaned) return null
      const comma = cleaned.lastIndexOf(',')
      const dot = cleaned.lastIndexOf('.')
      let normalized
      if (comma > dot) {
        normalized = cleaned.replace(/\./g, '').replace(',', '.')
      } else {
        normalized = cleaned.replace(/,/g, '')
      }
      const num = parseFloat(normalized)
      return isNaN(num) ? null : num
    }

    const reformatEl = (el) => {
      if (!el) return
      if (el.dataset.priceReformatted) return
      // Skip elements that have child elements (to avoid destroying HTML structure)
      if (el.querySelector('span, s, ins, del, a')) return
      const text = el.textContent || ''
      if (!text.trim() || !/\d/.test(text)) return
      const num = parsePrice(text)
      if (num !== null && num > 0) {
        el.textContent = shopifyFormatMoney(Math.round(num * 100))
        el.dataset.priceReformatted = '1'
      }
    }

    const PRICE_SELECTORS = [
      // Cart selectors
      '.cart__item__price',
      '.cart__item__price ins',
      '.cart__item__price del',
      '[data-cart-total]',
      '[data-cart-total-price]',
      '.cart__total__money',
      '.cart__discount__amount',
      '[data-left-to-spend]',
      // Product page selectors (leaf elements only, not parent containers)
      '.product__price--regular',
      '.product__price--compare',
      '.product-grid-item__price-new'
    ]

    const reformatAllPrices = (root = document) => {
      PRICE_SELECTORS.forEach((sel) => {
        root.querySelectorAll(sel).forEach((el) => {
          const ins = el.querySelector('ins')
          const del = el.querySelector('del')
          if (ins || del) {
            if (ins) reformatEl(ins)
            if (del) reformatEl(del)
          } else {
            reformatEl(el)
          }
        })
      })
    }

    reformatAllPrices()

    // Observe cart drawer for dynamic content changes
    const cartDrawer = document.querySelector('[data-cart-drawer]')
    if (cartDrawer) {
      new MutationObserver(() => reformatAllPrices(cartDrawer)).observe(cartDrawer, {
        childList: true,
        subtree: true
      })
    }

    // Observe cart page for dynamic content changes
    const cartPage = document.querySelector('[data-cart-page]')
    if (cartPage) {
      new MutationObserver(() => reformatAllPrices(cartPage)).observe(cartPage, {
        childList: true,
        subtree: true
      })
    }

    // Listen for theme cart events
    document.addEventListener('theme:cart:added', () => {
      setTimeout(() => reformatAllPrices(), 150)
    })

    window.__reformatPrices = reformatAllPrices
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceReformat)
  } else {
    initPriceReformat()
  }



   // judge.me aria label 

  document.addEventListener('DOMContentLoaded', function () {
    function fixJudgeMeLinks() {
      document.querySelectorAll('a.jdgm-carousel-item__product').forEach(function (a) {
        if (a.getAttribute('aria-label')) return;
        var titleEl = a.querySelector('.jdgm-carousel-item__product-title');
        var name = titleEl ? titleEl.textContent.trim() : '';
        if (!name) {
          var handle = a.getAttribute('data-preorder-handle') || a.getAttribute('d-handle') || '';
          name = handle.replace(/-/g, ' ').trim();
        }

        a.setAttribute('aria-label', 'Ver producto: ' + (name || 'producto'));
      });
    }
    fixJudgeMeLinks();
    setTimeout(fixJudgeMeLinks, 2000);
    setTimeout(fixJudgeMeLinks, 5000);
    var carousel = document.querySelector('.jdgm-carousel__item-wrapper');
    if (carousel && window.MutationObserver) {
      new MutationObserver(fixJudgeMeLinks).observe(carousel, { childList: true, subtree: true });
    }
  });

  // Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.


})()



